module.exports = {

	/**
	 * Gets the name.
	 *
	 * @return     {string}  The name.
	 */
	getName() {
		return "TBI Bank";
	},

	/**
	 * Gets the company full name.
	 *
	 * @return     {string}  The company name.
	 */
	getCompanyName() {
		return "TBI Bank";
	},

	/**
	 * Gets the logo.
	 *
	 * @return     {string}  The logo.
	 */
	getLogo() {
		return "images/logos/tbi.png";
	},

	/**
	 * Gets the agreement file.
	 *
	 * @return     {string}  The agreement file.
	 */
	getAgreementFile() {
		return "docs/tbi_gdpr_declaration_online.pdf";
	},

	/**
	 * Return the summary text.
	 *
     * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * 
     * @return     	string  The summary text.
	 */

	 summary(months, price) {
		return "<p>Вие избрахте покупка на изплащане с <strong>" + this.getCompanyName() + "</strong>. Обща стойност за плащане: <strong>" + this.total(months, price).toFixed(2) + "</strong> лв., " + months + " месечни вноски по <strong>" + this.perMonth(months, price).toFixed(2) + "</strong> лв.</p><p>Кредитните условия на " + this.getCompanyName() + " включват <a href='/" + this.getAgreementFile() + "' target='_blank'><strong>Декларация за съгласие за обработка на лични данни</strong></a>, с която потвърждавате, че сте съгласни личните Ви данни да бъдат обработвани от " + this.getCompanyName() + " по описания в документа начин и за целите, посочени в него.</p>";
	},

	/**
	 * Return available periods
	 *
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	availablePeriods(price) {
		var coefficents = {
			3 : null,
			6 : null,
			9 : null,
			12: null,
			15: null,
			18: null,
			24: null,
			36: null
        };

		return coefficents;
	},

	/**
	 * Return total price for leasing based on given months period
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	total(months, price)
	{
		var interestRate = 1 / 100;

		// X = A*(1+B*C)
		// X = Обща дължима сума
		// A = Сума на продукта
		// B = лихвен процент. При месечни вноски до 9 месеца лихвения процент е 1.5%, 
		// а при месечни вноски над 9 месеца лихвения процент е 1%
		// Edit: Лихвения процент от 21.10.2019 е 1% независимо от броя месечни вноски.
		return price * (1 + interestRate * months);
	},

	/**
	 * Returns per month price for leasing based on given months period
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	perMonth(months, price) 
	{
        return this.total(months, price) / months;
    }


}